import { GTM_ID_BY_LOCALES } from 'config';
import { LOCALE } from 'helpers/i18n';

export const GTMId = GTM_ID_BY_LOCALES[LOCALE];
export const TWO_YEARS_IN_DAYS = 730;
